<img
  src="assets/png/qiagen-top-left-pill.png"
  srcset="
    assets/png/qiagen-top-left-pill.png    1x,
    assets/png/qiagen-top-left-pill@2x.png 2x,
    assets/png/qiagen-top-left-pill@3x.png 3x
  "
  class="absolute top-0 left-[50px]"
  width="434"
  height="299"
/>
<img
  src="assets/png/qiagen-bottom-pills.png"
  srcset="
    assets/png/qiagen-bottom-pills.png    1x,
    assets/png/qiagen-bottom-pills@2x.png 2x,
    assets/png/qiagen-bottom-pills@3x.png 3x
  "
  class="absolute bottom-0 right-[15%]"
  width="701"
  height="475"
/>
<img
  src="assets/png/qiagen-right-pill.png"
  srcset="
    assets/png/qiagen-right-pill.png    1x,
    assets/png/qiagen-right-pill@2x.png 2x,
    assets/png/qiagen-right-pill@3x.png 3x
  "
  class="absolute top-1/2 right-0 -translate-y-1/2"
  width="203"
  height="314"
/>
<gnx-top-nav [activeMiniApp]="MiniApps.ClinicalDB" />
<div class="content">
  <div class="empty-small"></div>
  <div class="home-title">The Future of Genomic Medicine</div>
  @if (showSearch()) {
    <gnx-search />
  }
  @if (showSearch()) {
    <div
      class="create-case-buttons"
      gnxElementPermissionResolver
      #createAction="permissionresolver"
      [requiredActionPermission]="UserPermission.CreateCase"
    >
      <span>Create new case from:</span>
      <div matTooltip="Permission required for this action" [matTooltipDisabled]="createAction.isActionPermitted">
        <div class="create-case-btn" (click)="createCaseFromCMA()" [class.disabled]="!createAction.isActionPermitted">
          <div class="img-wrapper"><img src="assets/svg/from-cma.svg" /></div>
          <div>CMA</div>
        </div>
      </div>
      <div matTooltip="Permission required for this action" [matTooltipDisabled]="createAction.isActionPermitted">
        <div
          class="create-case-btn"
          (click)="createCaseFromReport()"
          [class.disabled]="!createAction.isActionPermitted"
        >
          <div class="img-wrapper"><img src="assets/svg/from-report-icon.svg" /></div>
          <div>Report</div>
        </div>
      </div>
      <div matTooltip="Permission required for this action" [matTooltipDisabled]="createAction.isActionPermitted">
        <div class="create-case-btn" (click)="createCaseFromVCF()" [class.disabled]="!createAction.isActionPermitted">
          <div class="img-wrapper"><img src="assets/svg/folder-white.svg" /></div>
          <div>VCF</div>
        </div>
      </div>
    </div>
  }
  <div class="empty-big"></div>
  <div class="home-terms">
    By selecting ‘Search’ you accept our
    <a href="https://www.genoox.com/terms/" target="_blank">Terms and Conditions</a>
    and
    <a href="https://www.genoox.com/privacy-policy/" target="_blank">Privacy Policy</a>
  </div>
</div>
